// Dil tercihinin saklandığı depo — diğer yüzeylerdeki eşleniğiyle aynı
// gerekçe: tarayıcı dışı bağlamda `localStorage` erişimin KENDİSİ atar.

import type { LocaleStorage } from "@novemai/i18n-sdk";

export const localeStorage: LocaleStorage | undefined =
  typeof window === "undefined" || typeof window.localStorage === "undefined"
    ? undefined
    : window.localStorage;
